import { render } from "./ArchiveItem.vue?vue&type=template&id=f4da2ea6"
import script from "./ArchiveItem.vue?vue&type=script&lang=js"
export * from "./ArchiveItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__